import request from '@/utils/request'

// 创建与真通讯录
export function createAddressBook(data) {
  return request({
    url: '/yuzhen/address-book/create',
    method: 'post',
    data: data
  })
}

// 更新与真通讯录
export function updateAddressBook(data) {
  return request({
    url: '/yuzhen/address-book/update',
    method: 'put',
    data: data
  })
}

// 删除与真通讯录
export function deleteAddressBook(id) {
  return request({
    url: '/yuzhen/address-book/delete?id=' + id,
    method: 'delete'
  })
}

// 获得与真通讯录
export function getAddressBook(id) {
  return request({
    url: '/yuzhen/address-book/get?id=' + id,
    method: 'get'
  })
}

// 获得与真通讯录分页
export function getAddressBookPage(query) {
  return request({
    url: '/yuzhen/address-book/page',
    method: 'get',
    params: query
  })
}

// 下载用户导入模板
export function importTemplate() {
  return request({
    url: '/yuzhen/address-book/get-import-template',
    method: 'get',
    responseType: 'blob'
  })
}

// 导出与真通讯录 Excel
export function exportAddressBookExcel(query) {
  return request({
    url: '/yuzhen/address-book/export-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}
